
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";

interface LessonHeaderProps {
  courseSlug: string | undefined;
  courseTitle: string;
  currentLesson: { title: string } | null;
  onOpenSidebar: () => void;
  isCompleted?: boolean;
  onMarkComplete?: () => void;
}

export function LessonHeader({
  courseSlug,
  courseTitle,
  currentLesson,
  onOpenSidebar,
  isCompleted,
  onMarkComplete
}: LessonHeaderProps) {
  return (
    <div className="bg-card border-b border-border/40">
      <div className="container flex items-center justify-between py-4">
        <div className="flex items-center gap-4">
          <button
            onClick={onOpenSidebar}
            className="md:hidden p-2 rounded-md hover:bg-muted"
            aria-label="Open sidebar"
          >
            <Menu className="h-5 w-5" />
          </button>
          
          <div>
            <Link to={`/courses/${courseSlug}`} className="text-sm text-primary hover:underline">
              {courseTitle}
            </Link>
            <h1 className="text-xl font-semibold">{currentLesson?.title}</h1>
          </div>
        </div>
        
        {onMarkComplete && (
          <button
            onClick={onMarkComplete}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm ${
              isCompleted 
                ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
                : "bg-primary/10 text-primary hover:bg-primary/20"
            }`}
          >
            {isCompleted ? "Completed" : "Mark as Complete"}
          </button>
        )}
      </div>
    </div>
  );
}
